import React, {useEffect} from "react";
import {Button, Form, Input, DatePicker, Select} from "antd";
import {useModel} from "../../../models";
import moment from "moment";

const {RangePicker} = DatePicker;

const rangeConfig = {
    rules: [{type: 'array', message: '请选择制单日期!'}],
};

export default function () {
    const [
        {supplierDict, purchaseReturnStatusDict},
        {getSupplierDict, getPurchaseReturnStatusDict, getInvoiceTypeDict}
    ] = useModel("cmDict");
    useEffect(() => {
        getSupplierDict();
        getPurchaseReturnStatusDict();
        getInvoiceTypeDict();
    })
    const [
        {searchParam, documentPageInfo},
        {setSearchParam, loadDocumentList, clearSearchParam}
    ] = useModel("purchaseRo");

    const [form] = Form.useForm();
    useEffect(() => {
        const {startEndDate = []} = searchParam;
        const [startTime, endTime] = startEndDate;
        form.setFieldsValue({...searchParam, startEndDate: [startTime?moment(startTime):"", endTime?moment(endTime):""]});
    }, [searchParam]);

    useEffect(() => {
        form.setFieldsValue(searchParam);
        // onReset();
    }, []);
    
    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
        const {pageSize, pageNum} = documentPageInfo;
        const {returnCode, supplierId, orderStatus} = searchParam;
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum,
            returnCode,
            supplierId,
            orderStatus,
        }
        loadDocumentList({showMsg: true, data});
    }

    const onReset = () => {
        form.resetFields();
        clearSearchParam();
        let data = {
            pageSize: 15,
            pageNum: 1,
        }
        loadDocumentList({showMsg: true, data});
    }
    return (
        <Form
            form={form}
            name="purchase_ro_search"
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            <Form.Item
                name="returnCode"
                label="退货单号"
            >
                <Input placeholder="退货单号" style={{width: "150px"}}/>
            </Form.Item>

            <Form.Item
                name="supplierId"
                label="供应商"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择供应商"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={supplierDict}
                    style={{width: "150px"}}
                    dropdownClassName="dark-select"
                />
            </Form.Item>
            <Form.Item
                name="orderStatus"
                label="状态"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择状态"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={purchaseReturnStatusDict}
                    style={{width: "150px"}}
                />
            </Form.Item>

            <Form.Item name="startEndDate" label="制单日期" {...rangeConfig}>
                <RangePicker/>
            </Form.Item>

            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            htmlType="submit"
                            type="primary"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="button"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}